import { render, staticRenderFns } from "./RelatedTopicForm.vue?vue&type=template&id=64675096&"
import script from "./RelatedTopicForm.vue?vue&type=script&lang=js&"
export * from "./RelatedTopicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports